"use client";
import { cn } from "@repo/utils/cn";
import { useIsSandbox } from "@repo/utils/hooks/useIsSandbox";
import { PropsWithChildren } from "react";

export const OperatorBaseLayout = ({ children }: PropsWithChildren) => {
  const isSandbox = useIsSandbox();

  return (
    <div
      className={cn(
        "relative overflow-y-auto h-screen scroll-container",
        isSandbox ? "h-[calc(100vh-32px)]" : "h-screen",
      )}
    >
      {children}
    </div>
  );
};
